"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoundButton = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var RoundButton = _styledComponents.default.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border: 1px solid #53b7c2;\n  width: 36px;\n  height: 36px;\n  border-radius: 100%;\n  color: #ffc033;\n  font-size: 8px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  background: transparent;\n  line-height: normal;\n  justify-content: center;\n  font-family: 'Verdana', Arial, serif;\n  font-weight: 600;\n"])));
exports.RoundButton = RoundButton;